export const SETTINGS_BOOTSTRAP = 'settings.bootstrap';

const makeId = (id: string) => `${SETTINGS_BOOTSTRAP}${id}`;

export const BASE = makeId('');
export const BACK = makeId('/back');
export const INVITATIONS = makeId('/invitations');
export const API_CREDS = makeId('/api-creds');
export const DIVIDER = makeId('.divider');
